export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7157.4b4ca01a.jpg";